import { Backdrop, CircularProgress } from '@mui/material';
import { COLOR_WHITE } from '../../popTheme';

export const LoadingBackdrop = () => {
  return (
    <Backdrop
      sx={{
        color: COLOR_WHITE,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
      data-testid={'loading-backdrop'}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
